export const isDev: boolean = typeof window !== 'undefined' && window._env_?.DEVELOPMENT === '1'

export function logDev(...args: unknown[]): void {
  if (isDev) {
    console.log(...args)
  }
}

export function warnDev(...args: unknown[]): void {
  if (isDev) {
    console.warn(...args)
  }
}

export function errorDev(...args: unknown[]): void {
  if (isDev) {
    console.error(...args)
  }
}
